<template>
  <div>
    <div class="intros">
      <div class="changenav">
        <ul>
          <li
            :class="{active:contentIndex==index}"
            @click="changeIndex(index)"
            v-for="(item,index) in cartList"
            :key="index"
          >{{item}}</li>
        </ul>
      </div>
      <div class="videostart">
        <div class="showinfor">
          <span v-if="contentIndex == 0">{{tvideoPagerParam.total}}{{$t('global.个视频')}}</span>
          <span v-else>{{shideoPagerParam.total}}{{$t('global.个视频')}}</span>
          <div class="rightside" v-if="contentIndex == 0">
            <div class="defaultstate" v-show="!isEdit">
              <a @click="showAdd">{{$t('global.新增')}}</a>
              <a @click="editBtn">{{$t('global.编辑')}}</a>
            </div>
            <div class="editstate" v-if="isEdit">
              <el-checkbox v-model="checked" @change="checkAll">{{$t('global.全选')}}</el-checkbox>
              <a @click="rankPost">{{$t('global.按序号排序')}}</a>
              <a @click="deleteTopicVideo()">{{$t('global.删除')}}</a>
              <a @click="backBtn">{{$t('global.返回')}}</a>
            </div>
          </div>
        </div>

        <div class="myvidestart" v-if="contentIndex == 0">
          <ul>
            <li class="userinforbox" v-for="(item , index) of currentTopicVideo" :key="index">
              <router-link target="_blank" :to="'/video/detail?id='+item.videoId">
                <span class="videotime">{{item.duration | secondToDate}}</span>
                <img
                  class="videothump"
                  :src="item.thumb | imageUrl('','',256)"
                  @click="selectItem(item.videoId)"
                />
                <div class="videoplays" v-if="showPlay">
                  <svg
                    viewBox="298 388 16 16"
                    fill="#fff"
                    class="iris_ic is&amp;#45;&amp;#45;undefined"
                  >
                    <path d="M298 404v-16l16 8" />
                  </svg>
                </div>

                <p
                  style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
                  class="titlelist"
                >{{item.title}}</p>
                <div class="userheadinfor">
                  <div class="userleft">
                    <img :src="item.avatar | imageUrl('/static/profile_img_default.png',52,52)" />
                    <span>{{item.nickName}}</span>
                  </div>
                  <div class="userright">
                    <img src="/static/home/images/eyes.png" />
                    <span>{{item.viewCount}}</span>
                  </div>
                </div>
              </router-link>
              <div class="checkarea" v-show="isShow">
                <input type="text" v-model="item.rank" @change="changeRank(item)" />
                <span class="videotime">{{item.duration | secondToDate}}</span>
                <div
                  class="checkedbox"
                  @click="editSelect(deleteVideo,item.videoId)"
                  :class="{showbox:getSelect(deleteVideo,item.videoId)}"
                ></div>
              </div>
            </li>
          </ul>
          <pages
            :page-size="tvideoPagerParam.pageSize"
            :page-count="tvideoPagerParam.pageCount"
            :current-page="tvideoPagerParam.currentPage"
            :total="tvideoPagerParam.total"
            @current-page-changed="OnTvideoCurrentPageChanged"
          ></pages>
        </div>

        <div class="myvideocheck" v-if="contentIndex == 1">
          <ul>
            <li class="userinforbox" v-for="(item , index) of currentTopicVideo" :key="index">
              <img class="leftpic" :src="item.thumb | imageUrl('',224,128)" />
              <div class="checkcenter">
                <p
                  style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
                >{{item.title}}</p>
                <div class="userheadinfor">
                  <div class="userleft">
                    <img :src="item.avatar | imageUrl('/static/profile_img_default.png',52,52)" />
                    <span>{{item.nickName}}</span>
                  </div>
                  <div class="userright">
                    <img src="/static/home/images/eyes.png" />
                    <span>{{item.viewCount}}</span>
                  </div>
                </div>
              </div>

              <div class="approved">
                <p>
                  {{$t('global.推荐人')}}：
                  <img
                    :src="item.recommendAvatar|imageUrl('static/home/images/avatar.png',40,40)"
                  />
                  <span>{{item.recommendNickName||'MANAMANA'}}</span>
                </p>
                <div v-if="item.status !=2 && item.status != 3">
                  <a @click="noPassVideo(item.videoId)">{{$t('global.不通过')}}</a>
                  <a @click="passVideo(item.videoId)">{{$t('global.通过')}}</a>
                </div>
                <div v-else>
                  <a @click="noPassVideo(item.videoId)" v-if="item.status == 2">{{$t('global.不通过')}}</a>
                  <a v-else @click="passVideo(item.videoId)">{{$t('global.通过')}}</a>
                </div>
              </div>
            </li>
          </ul>
          <pages
            :page-size="shideoPagerParam.pageSize"
            :page-count="shideoPagerParam.pageCount"
            :current-page="shideoPagerParam.currentPage"
            :total="shideoPagerParam.total"
            @current-page-changed="OnShideoCurrentPageChanged"
          ></pages>
        </div>
      </div>
    </div>

    <template v-if="isShowAdd">
      <div>
        <div class="addfixwindow"></div>
        <div class="fixconent">
          <p>{{$t('global.视频选择')}}</p>
          <div class="headsearch">
            <input
              type="text"
              :placeholder="$t('global.搜索视频')"
              v-model="keyword"
              @keyup.enter="getAllVideo"
            />
            <img src="/static/home/images/search.png" @click="getAllVideo" />
          </div>
          <div class="hostactivity">
            <ul>
              <!--<li v-for="item in exitsList">{{item}}</li>-->
              <template v-for="item in allVideoList">
                <li
                  v-if="isShowLi && item.videoId"
                  @click="addSelectVideo(item.videoId)"
                  :key="item.videoId"
                >
                  <router-link target="_blank" :to="'/video/detail?id='+item.videoId">
                    <img class="hostac" :src="item.thumb | imageUrl('',920,270)" />
                  </router-link>
                  <p
                    style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;line-clamp: 2;"
                  v-html="item.title"></p>
                  <div
                    class="checkarea"
                    v-if="!getSelect(exitsList,item.videoId)"
                    :class="{show:true}"
                  >
                    <div class="checkedbox" :class="{showbox:getSelect(selectAddVideo,item.videoId)}"></div>
                  </div>
                  <a class="addsed" v-else>{{$t('global.已添加')}}</a>
                </li>
              </template>
            </ul>
            <pages
              :page-size="videoPagerParam.pageSize"
              :page-count="videoPagerParam.pageCount"
              :current-page="videoPagerParam.currentPage"
              :total="videoPagerParam.total"
              @current-page-changed="OnVideoCurrentPageChanged"
            ></pages>
          </div>
          <img src="/static/uploadvideo/closepopus.png" class="closepopus" @click="hiddenAdd" />
          <div class="underbutton">
            <span>
              {{$t('global.已选择')}}
              <em>{{selectAddVideo.length}}</em>
              {{$t('global.个视频')}}
            </span>
            <a @click="sureAdd" class="sure">{{$t('global.确定')}}</a>
            <a @click="hiddenAdd" class="cancel">{{$t('global.取消')}}</a>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import pages from "@/components/pages.vue";

export default {
  name: "itemStep3",
  components: {
    pages
  },
  data() {
    return {
      topicId: -1,
      currentTopicVideo: [],
      isShowAdd: false,
      isShowLi: true,
      myVideoShow: true,
      num: 0,
      isShowBox: false,
      isNone: false,
      checkState: true,
      istrue: 0,
      status: 2,
      type: 1,
      cartList: [this.$t("global.视频管理"), this.$t("global.视频审核")],
      videoPagerParam: {
        pageSize: 6,
        pageCount: 1,
        currentPage: 1,
        total: 0
      },
      tvideoPagerParam: {
        pageSize: 9,
        pageCount: 1,
        currentPage: 1,
        total: 0
      },
      shideoPagerParam: {
        pageSize: 4,
        pageCount: 1,
        currentPage: 1,
        total: 0
      },

      contentIndex: 0,
      checked: false,
      isEdit: false,
      isShow: false,
      allVideoList: [],
      exitsList: [],
      keyword: "",
      selectAddVideo: [],
      deleteVideo: [],
      rankVideoList: [],
      addstate: true,
      pageIndex: 1,
      showPlay: true
    };
  },
  watch: {
    "agerParam.currentPage"() {
      this.getAllVideo();
    }
  },
  created() {
    this.topicId = this.$route.params.id;
    this.getTopicVideoList();
  },
  methods: {
    editBtn() {
      this.isEdit = true;
      this.isShow = true;
      this.showPlay = false;
    },
    backBtn() {
      this.isEdit = false;
      this.isShow = false;
      this.showPlay = true;
    },
    hiddenAdd() {
      this.isShowAdd = false;
      document.documentElement.style.overflowY = "scroll";
      //清空选择的
      this.selectAddVideo = [];
      this.keyworld = "";
    },
    showAdd() {
      this.isShowAdd = true;
      this.getAllVideo();
      document.documentElement.style.overflowY = "hidden";
    },
    getAllVideo() {
      let params = {};
      var $this = this;
      params = {
        searchTagForms: [],
        type: 1,
        pageIndex: this.videoPagerParam.currentPage,
        pageSize: this.videoPagerParam.pageSize,
        keyword: this.keyword
      }
      this.$http
        // .get("/api/video/findList", {
        //   params: {
        //     orderBy: 1,
        //     pageSize: this.videoPagerParam.pageSize,
        //     pageIndex: this.videoPagerParam.currentPage,
        //     keyword: this.keyword
        //   }
        // })
        .post("/api/search/list2",params, {
            headers: {
              "Content-Type": "application/json",
            },
        })
        .then(response => {
          $this.allVideoList =response.data.pageList.list;
          this.videoPagerParam = {
            pageSize: response.data.pageList.pageSize,
            pageCount: response.data.pageList.totalPage,
            currentPage: response.data.pageList.pageIndex,
            total: response.data.pageList.totalRecord
          };
        });
    },
    sureAdd() {
      if (this.selectAddVideo.length == 0) {
        this.$message({
          message: this.$t("global.请选择要添加的视频"),
          type: "error",
          duration: 1000
        });
        return;
      }
      let $this = this;
      this.$http
        .post("/api/u/topic/createBatchVideo", {
          topicId: this.topicId,
          videoIds: this.selectAddVideo.join()
        })
        .then(response => {
          if (response.code == "OK") {
            this.hiddenAdd();
            $this.$message({
              message: this.$t("global.添加成功"),
              type: "success",
              duration: 1000
            });

            $this.getTopicVideoList();
          } else {
            $this.$message({
              message: this.$t("global.添加失败"),
              type: "error",
              duration: 1000
            });
          }
        });
    },
    addSelectVideo(id) {
      let index = this.selectAddVideo.indexOf(id);
      if (index != -1) {
        this.selectAddVideo.splice(index, 1);
      } else {
        this.selectAddVideo.push(id);
      }
    },
    //验证是否选中
    getSelect(list, id) {
      if (list.indexOf(id) != -1) {
        return true;
      } else {
        return false;
      }
    },
    changeRank(item) {
      let index = this.rankVideoList.indexOf(item);
      if (index == -1) {
        this.rankVideoList.push(item);
      }
    },

    OnVideoCurrentPageChanged(val) {
      this.videoPagerParam.currentPage = val;
      this.getAllVideo();
    },
    OnTvideoCurrentPageChanged(val) {
      this.tvideoPagerParam.currentPage = val;
      this.getTopicVideoList();
    },
    OnShideoCurrentPageChanged(val) {
      this.shideoPagerParam.currentPage = val;
      this.getTopicVideoList();
    },

    editSelect(list, id) {
      let index = list.indexOf(id);
      if (index != -1) {
        list.splice(index, 1);
      } else {
        list.push(id);
      }
    },
    changeIndex(index) {
      this.type = index == 0 ? 1 : 2;

      this.getTopicVideoList();
      this.contentIndex = index;
      if (this.contentIndex == 1) {
        this.isNone = true;
      } else {
        this.isNone = false;
      }
    },

    getTopicVideoList() {
      let $this = this;
      let params = {};
      if (this.type == 1) {
        params = { pageIndex: this.tvideoPagerParam.currentPage, pageSize: 9 };
      } else {
        params = { pageIndex: this.shideoPagerParam.currentPage, pageSize: 4 };
      }

      this.$http
        .get(
          "/api/u/topic/videoPageList?topicId=" +
            $this.topicId +
            "&type=" +
            this.type +
            "&orderBy=0",
          { params: params }
        )
        .then(function(response) {
          let pagelist = response.data.pageList;
          $this.currentTopicVideo = pagelist.list;
          //更新是否已添加状态
          $this.exitsList = response.data.ids;
          if ($this.type == 1) {
            $this.tvideoPagerParam = {
              pageSize: 9,
              pageCount: pagelist.totalPage,
              currentPage: pagelist.pageIndex,
              total: pagelist.totalRecord
            };
          } else {
            $this.shideoPagerParam = {
              pageSize: 4,
              pageCount: pagelist.totalPage,
              currentPage: pagelist.pageIndex,
              total: pagelist.totalRecord
            };
          }
        });
    },
    deleteTopicVideo() {
      // this.isShowLi = false
      if (this.deleteVideo.length == 0) {
        this.$message({
          message: this.$t("global.请选择要删除的视频"),
          type: "error",
          duration: 1000
        });
        return;
      }

      let $this = this;
      this.$http
        .post("/api/topic/deleteVideoBatch", {
          topicId: $this.topicId,
          ids: this.deleteVideo.join()
        })
        .then(response => {
          if (response.code == "OK") {
            $this.$message({
              message: this.$t("global.删除成功"),
              type: "success",
              duration: 1000
            });
            $this.getTopicVideoList();
            $this.backBtn();
          } else {
            $this.$message({
              message: this.$t("global.删除失败"),
              type: "error",
              duration: 1000
            });
          }
        });
    },
    passVideo(videoId) {
      let $this = this;
      this.$http
        .post("/api/topic/passVideo", {
          topicId: $this.topicId,
          videoId: videoId,
          status: 2
        })
        .then(response => {
          if (response.code == "OK") {
            $this.$message({
              message: this.$t("global.操作成功"),
              type: "success",
              duration: 1000
            });
            $this.getTopicVideoList();
          } else {
            $this.$message({
              message: this.$t("global.操作失败"),
              type: "error",
              duration: 1000
            });
          }
        });
    },
    noPassVideo(videoId) {
      let $this = this;
      this.$http
        .post("/api/topic/passVideo", {
          topicId: $this.topicId,
          videoId: videoId,
          status: 3
        })
        .then(response => {
          if (response.code == "OK") {
            $this.$message({
              message: this.$t("global.操作成功"),
              type: "success",
              duration: 1000
            });
            $this.getTopicVideoList();
          } else {
            $this.$message({
              message: this.$t("global.操作失败"),
              type: "error",
              duration: 1000
            });
          }
        });
    },
    /**
     * 执行排序动作
     */
    rankPost() {
      if (this.rankVideoList != null && this.rankVideoList.length > 0) {
        this.$http
          .post("/api/u/topic/video/rank", {
            topicId: this.topicId,
            rankVideoList: JSON.stringify(this.rankVideoList)
          })
          .then(response => {
            if (response.code == "OK") {
              this.$message.success(this.$t("global.排序成功"));
              this.currentTopicVideo == response.data;
              this.rankVideoList = [];
              this.getTopicVideoList();
              this.backBtn();
            }
          });
      }
    },
    checkAll(value) {
      this.checked = value;
      if (this.checked) {
        for (var i = 0; i < this.currentTopicVideo.length; i++) {
          this.deleteVideo.push(this.currentTopicVideo[i].videoId);
        }
      } else {
        this.deleteVideo = [];
      }
    }
  }
};
</script>

<style scoped>
.intros {
  padding: 22px 50px 46px;
  overflow: hidden;
  background-color: #fff;
  min-height: calc(100vh - 250px);
}
.changenav {
  overflow: hidden;
  border-bottom: 1px solid #edecf1;
}
.changenav li {
  float: left;
  color: #999;
  font-size: 14px;
  cursor: pointer;
  margin-right: 30px;
}
.changenav li.active {
  color: #000;
  font-weight: bold;
  padding-bottom: 12px;
  border-bottom: 2px solid #333;
}

.showinfor {
  height: 30px;
  color: #999;
  line-height: 30px;
  font-size: 12px;
  overflow: hidden;
  margin-top: 8px;
}
.showinfor > span {
  float: left;
}
.showinfor .rightside {
  float: right;
}
.showinfor .rightside .none {
  display: none;
}
.showinfor .rightside a {
  display: inline-block;
  height: 30px;
  padding: 0 18px;
  color: #fff;
  border-radius: 2px;
  margin-left: 10px;
  cursor: pointer;
  background-color: rgba(0, 173, 239, 1);
}
.defaultstate {
  text-align: right;
}
input[type="radio"] {
  position: relative;
  top: 2px;
  margin: 0 10px;
}

.myvidestart {
  margin: 20px 0;
  overflow: hidden;
}
.myvidestart ul {
  overflow: auto;
}

.myvidestart li {
  position: relative;
  float: left;
  width: calc((100% - 40px) / 3);
  height: 214px;
  margin: 0 20px 20px 0;
  overflow: hidden;
}
.checkarea {
  position: absolute;
  width: 100%;
  top: 105px;
  left: 0;
  z-index: 999;
  padding: 0 8px;
  height: 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.checkarea input[type="text"] {
  width: 54px;
  text-align: right;
  padding-right: 5px;
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(151, 151, 151, 1);
  box-sizing: border-box;
}
.checkarea .checkedbox {
  float: right;
  width: 20px;
  height: 20px;
  cursor: pointer;
  background: url(/static/home/images/checked.png) no-repeat;
  background-size: 100% 100%;
}
.checkarea .showbox {
  background: url("/static/home/images/ischecked.png") no-repeat;
  background-size: 100% 100%;
}

.myvidestart li:nth-child(3n) {
  margin-right: 0;
}
.myvidestart li .videothump {
  width: 100%;
  height: 128px;
  border-radius: 5px;
  cursor: pointer;
}
.myvidestart li .titlelist {
  width: 284.66px;
  margin: 8px 0 5px 0;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  height: 44px;
  overflow: hidden;
  line-height: 22px;
  cursor: pointer;
  text-overflow: ellipsis;
}
.myvidestart .videotime {
  float: right;
  padding: 3px 6px;
  color: rgba(255, 255, 255, 1);
  background: rgba(0, 0, 0, 0.7);
  border-radius: 2px;
  margin-left: 8px;
}
.userheadinfor {
  font-size: 12px;
  color: #999;
}
.userheadinfor .userleft {
  float: left;
  cursor: pointer;
}
.userheadinfor .userleft img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
}
.userheadinfor .userleft span {
  position: relative;
  top: 2px;
}
.userheadinfor .userright {
  float: right;
  margin-top: 7px;
}
.userheadinfor .userright img {
  position: relative;
  width: 20px;
  height: 12px;
  top: -1px;
}

/*shenhe*/
.myvideocheck {
  overflow: hidden;
  margin-top: 20px;
}
.myvideocheck li {
  overflow: hidden;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #edecf1;
}
.myvideocheck li:last-child {
  border-bottom: none;
}
.myvideocheck li .leftpic {
  float: left;
  width: 227px;
  height: 128px;
  margin-right: 20px;
  border-radius: 5px;
}
.checkcenter {
  float: left;
  width: 300px;
  overflow: hidden;
}
.checkcenter p {
  font-size: 14px;
  color: #333;
  height: 38px;
  overflow: hidden;
  cursor: pointer;
}
.checkcenter .userheadinfor {
  overflow: hidden;
  margin-top: 62px;
}
.approved {
  float: left;
  margin-left: 50px;
  overflow: hidden;
}
.approved img {
  width: 20px;
  height: 20px;
}
.approved div a {
  display: inline-block;
  width: 64px;
  height: 30px;
  font-size: 14px;
  color: #999;
  cursor: pointer;
  text-align: center;
  line-height: 30px;
  border-radius: 2px;
  box-sizing: border-box;
}
.approved div {
  margin-top: 15px;
}
.approved div a:first-child {
  border: 1px solid rgba(224, 224, 224, 1);
  margin-right: 8px;
}
.approved div a:last-child {
  color: #fff;
  background: rgba(0, 173, 239, 1);
}

.fixconent .checkarea {
  display: block;
  top: 70px;
}
.fixconent .checkarea input {
  display: none;
}

.hostactivity ul {
  width: 100%;
}
.hostactivity li {
  position: relative;
  float: left;
  width: calc((100% - 40px) / 3);
  margin: 24px 22px 20px 0;
}
.hostactivity li:nth-child(3n) {
  margin-right: 0;
}
.hostactivity li .hostac {
  width: 100%;
  height: 135px;
  border-radius: 5px;
}
.hostactivity li a {
  display: inline-block;
  overflow: hidden;
}
.hostactivity li p {
  width: 169px;
  margin: 5px 0;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  height: 44px;
  overflow: hidden;
  line-height: 22px;
  text-overflow: ellipsis;
}
.hostactivity li span {
  font-size: 12px;
  color: #999;
}

.addfixwindow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.5;
  z-index: 999;
  background-color: #000;
}
.fixconent {
  position: fixed;
  width: 607px;
  height: 659px;
  top: 50%;
  left: 50%;
  z-index: 1000;
  transform: translate(-50%, -50%);
  background-color: #fff;
}
.fixconent > p {
  height: 50px;
  color: #000;
  font-size: 20px;
  font-weight: bold;
  padding: 0 26px;
  line-height: 50px;
  border-bottom: 1px solid #edecf1;
  box-sizing: border-box;
}
.headsearch {
  position: relative;
  padding: 0 26px;
  margin: 20px auto 0;
}
.headsearch input {
  width: 100%;
  height: 30px;
  border-radius: 5px;
  padding-left: 10px;
  background: rgba(245, 245, 245, 1);
  box-sizing: border-box;
}
.headsearch img {
  position: absolute;
  top: 5px;
  right: 36px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.fixconent .hostactivity {
  position: relative;
  padding: 0 30px;
  overflow: hidden;
  height: 500px;
  border-bottom: 1px solid #edecf1;
  box-sizing: border-box;
}
.fixconent .hostactivity li {
  margin: 20px 20px 0 0;
  height: 170px;
}
.fixconent .hostactivity li:nth-child(3n) {
  margin-right: 0;
}
.fixconent .hostactivity li .hostac {
  height: 95px;
}
.fixconent .hostactivity li p {
  font-size: 14px;
}
.fixconent .hostactivity li p >>> em{
  font-style: normal!important;
}
.fixconent .hostactivity .pages {
  position: absolute;
  margin: 0;
  left: 50%;
  bottom: 10px;
  transform: translate(-50%, 0);
}
.fixconent .underbutton {
  font-size: 12px;
  color: #999;
  height: 30px;
  padding: 0 30px;
  margin-top: 15px;
  line-height: 30px;
}
.fixconent .underbutton span {
  float: left;
}
.fixconent .underbutton a {
  float: right;
  display: inline-block;
  width: 64px;
  height: 30px;
  cursor: pointer;
  line-height: 30px;
  text-align: center;
  border-radius: 2px;
  box-sizing: border-box;
}
.fixconent .underbutton a.sure {
  color: #fff;
  margin-left: 13px;
  background: rgba(0, 173, 239, 1);
}
.fixconent .underbutton a.cancel {
  color: #999;
  border: 1px solid rgba(224, 224, 224, 1);
}
.fixconent .closepopus {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 17px;
  height: 17px;
  cursor: pointer;
}
.underbutton em {
  font-style: normal;
}
.intros {
  border-top: 1px solid rgba(238, 238, 238, 1);
  box-sizing: border-box;
}
.setting-layout .steps {
  width: 791px;
}
.addsed {
  float: right;
  display: inline-block;
  width: 44px;
  height: 18px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  background: rgba(0, 173, 239, 1);
  border-radius: 2px;
}
.userinforbox a .videotime {
  position: absolute;
  right: 8px;
  bottom: 89px;
}
.userinforbox .videoplays {
  position: absolute;
  width: 65px;
  height: 40px;
  left: 10px;
  bottom: 97px;
  border-radius: 5px;
  background-color: rgba(23, 34, 35, 0.75);
  opacity: 0;
  -webkit-transform: translateY(15px);
  transform: translateY(15px);
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}
.userinforbox .videoplays svg {
  width: 18px;
  height: 18px;
  margin: 10px 0 0 23px;
}
.userinforbox .videoplays:hover {
  background-color: #00adef;
  cursor: pointer;
}
.userinforbox > a:hover .videoplays {
  opacity: 1;
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  -webkit-transition: all 0.2s ease-in;
}
.userinforbox > a {
  display: inline-block;
  height: 128px;
}
</style>





// WEBPACK FOOTER //
// src/pages/v2/subject/step/Step3.vue